import { RouteType } from "routes/types";
import { lazy } from "react";

const Element = lazy(() => import("./index"));

const route: RouteType = {
  id: 1200,
  parentId: 1000,
  name: "Applications",
  label: "Applications",
  path: "applications",
  element: Element,
  footer: true,
  user: false,
  admin: false,
  hidden: false,
};

export default route;
